import React from 'react';
import { Table, Switch, message, Empty, Alert } from 'antd';
import { useListFeatureFlagsQuery, useToggleFeatureFlagMutation } from '../services/adminApi';
import AdminPageHeader, { adminPanelStyle } from './AdminPageHeader';

export default function FeatureFlagsPage() {
  const { data, isLoading, isError, error } = useListFeatureFlagsQuery();
  const [toggleFlag] = useToggleFeatureFlagMutation();

  const handleToggle = async (key, enabled) => {
    try {
      await toggleFlag({ key, enabled }).unwrap();
      message.success(`Flag "${key}" ${enabled ? 'enabled' : 'disabled'}`);
    } catch (err) {
      message.error(err.data?.title || 'Failed to toggle flag');
    }
  };

  const columns = [
    { title: 'Key', dataIndex: 'key', key: 'key' },
    { title: 'Description', dataIndex: 'description', key: 'description' },
    {
      title: 'Enabled',
      dataIndex: 'enabled',
      key: 'enabled',
      width: 100,
      render: (enabled, record) => (
        <Switch
          checked={!!enabled}
          onChange={(checked) => handleToggle(record.key, checked)}
        />
      ),
    },
    {
      title: 'Updated',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 170,
      render: (d) => (d ? new Date(d).toLocaleString() : '—'),
    },
  ];

  return (
    <div>
      <AdminPageHeader
        title="Feature Flags"
        subtitle="Toggle platform capabilities without a deploy"
      />

      {isError && (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          message={error?.data?.title || 'Failed to load feature flags'}
        />
      )}

      <div style={adminPanelStyle}>
        <Table
          dataSource={data?.items}
          columns={columns}
          loading={isLoading}
          rowKey="key"
          pagination={false}
          size="middle"
          locale={{ emptyText: <Empty description="No feature flags configured" /> }}
        />
      </div>
    </div>
  );
}
